import React, { useState, useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { searchSite } from '../utils/searchData';
import './SearchResults.css';

const SearchResults = () => {
  const location = useLocation();
  const [searchQuery, setSearchQuery] = useState('');
  const [results, setResults] = useState([]);
  const [isSearching, setIsSearching] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const query = params.get('q') || '';
    setSearchQuery(query);
    
    if (query.trim().length > 0) {
      setIsSearching(true);
      const searchResults = searchSite(query);
      setResults(searchResults);
      setIsSearching(false);
    } else {
      setResults([]);
    }
  }, [location.search]);

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim().length > 0) {
      window.location.href = `/search?q=${encodeURIComponent(searchQuery.trim())}`;
    }
  };

  return (
    <div className="search-results-container">
      <div className="search-results-content">
        <div className="search-results-main">
          <section className="search-section">
            <h1 className="search-title">Search Results</h1>
            
            <form className="search-form" onSubmit={handleSearch}>
              <div className="search-input-wrapper">
                <input
                  type="text"
                  className="search-input"
                  placeholder="Search the site..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
                <button type="submit" className="search-button">
                  <span className="search-icon">🔍</span>
                </button>
              </div>
            </form>

            {isSearching ? (
              <div className="search-loading">Searching...</div>
            ) : searchQuery.trim().length > 0 ? (
              <>
                <div className="results-header">
                  <p className="results-count">
                    {results.length > 0 
                      ? `Found ${results.length} result${results.length !== 1 ? 's' : ''} for "${searchQuery}"`
                      : `No results found for "${searchQuery}"`
                    }
                  </p>
                </div>

                {results.length > 0 ? (
                  <div className="results-list">
                    {results.map((result, index) => (
                      <div key={index} className="result-item">
                        <div className="result-category">{result.category}</div>
                        <h2 className="result-title">
                          <Link to={result.url}>{result.title}</Link>
                        </h2>
                        <p className="result-snippet">{result.snippet}</p>
                        <Link to={result.url} className="result-link">
                          View Page →
                        </Link>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="no-results">
                    <p>We couldn't find any results matching your search.</p>
                    <p>Try different keywords or browse our services:</p>
                    <ul className="suggestions-list">
                      <li><Link to="/system-certification">System Certification</Link></li>
                      <li><Link to="/product-certification">Product Certification</Link></li>
                      <li><Link to="/quality-certification">Quality Certification</Link></li>
                      <li><Link to="/about">About Us</Link></li>
                      <li><Link to="/contact">Contact</Link></li>
                    </ul>
                  </div>
                )}
              </>
            ) : (
              <div className="search-prompt">
                <p>Enter a search term to find information across our website.</p>
              </div>
            )}
          </section>
        </div>

        <aside className="search-sidebar">
          <div className="sidebar-section">
            <h2 className="sidebar-title">Our Services</h2>
            <ul className="sidebar-links">
              <li><Link to="/system-certification">System Certification</Link></li>
              <li><Link to="/product-certification">Product Certification</Link></li>
              <li><Link to="/quality-certification">Quality Certification</Link></li>
            </ul>
          </div>
        </aside>
      </div>
    </div>
  );
};

export default SearchResults;

